import PrizeLandingPage from 'components/prize-landing-pages/PrizeLandingPage';
import MainLayout from 'components/layout/MainLayout';
import { ASSET_PREFIX } from 'utils/constants';
import GreenPageSection from 'components/GreenPageSection';
import Subheading from 'components/Subheading';
import RoundedButton from 'components/RoundedButton';
import ImageWithContentSection from 'components/prize-landing-pages/ImageWithContentSection';
import HowItWorksAndChoosePlanSection from 'components/prize-landing-pages/HowItWorksAndChoosePlanSection';
import React from 'react';
import { scrollToSection } from 'utils/common';
import WinnerContentSection from 'components/prize-landing-pages/WinnerContentSection';
import { NextSeo } from 'next-seo';

const StayAtGiraffeManor = () => {
  const imageDirectory = `${ASSET_PREFIX}/images/prize-landing-pages/stay-at-giraffe-manor`;

  const handleScrollToEntryMethodCards = () => {
    scrollToSection('#howItWorksAndChoosePlanSection');
  };

  return (
    <MainLayout paddedMaxWidthContainer={false}>
      <NextSeo
        title="DAYMADE | Win A Stay In Giraffe Manor Worth £100k"
        description="Enter our weekly draw for the chance to win a 7-day trip for up to 6 people in iconic Giraffe Manor in Nairobi plus £20,000 spending money!"
        canonical='https://www.daymade.co.uk/prizes/details/win-giraffe-manor-stay'
        openGraph={{
          title: 'DAYMADE | Win A Stay In Giraffe Manor Worth £100k',
          description: 'Enter our weekly draw for the chance to win a 7-day trip for up to 6 people in iconic Giraffe Manor in Nairobi plus £20,000 spending money!',
        }}
      />

      <div id="top-of-page" />

      <PrizeLandingPage>
        <img
          src={`${imageDirectory}/hero.png`}
          className='hero'
          alt="family eating breakfast while full-grown adult giraffe sticks its head through the window"
        />

        <GreenPageSection additionalClassName='pageTitleGreenSectionContainer'>
          <Subheading Tag='h1' className='pageTitle'>
            Win A Stay In Giraffe Manor<br />
            <span style={{ fontSize: '2.2em', display: 'block' }}>
              Worth&nbsp;<strong>£100k</strong>
            </span>
          </Subheading>
          <p>
            Enter our weekly draw for the chance to win a 7-day trip for up to 6 people in iconic Giraffe Manor in Nairobi plus £20,000 spending money
          </p>
          <RoundedButton onClick={handleScrollToEntryMethodCards} style={{ width: 280 }}>
            Enter Now
          </RoundedButton>
          <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', margin: '3em 1em 0', width: '100%', maxWidth: 450 }}>
            <a href='https://uk.trustpilot.com/review/daymade.co.uk' target='_blank' style={{ margin: '0 0 2em 0', width: '35%' }}>
              <img src={`${ASSET_PREFIX}/images/play-free-lp/trustpilot-logo-grey.svg`} style={{ width: '100%' }} />
            </a>
            <a href='https://www.veritree.com/' target='_blank' style={{ margin: '0 0 2em 0', width: '50%', display: 'flex', alignItems: 'center', textAlign: 'left', wordBreak: 'break-word', whiteSpace: 'break-spaces' }}>
              <img src={`${ASSET_PREFIX}/images/veritree-logo-dark.svg`} style={{ width: '25%', marginRight: '0.5em' }} />
              Plant a tree with every purchase
            </a>
          </div>
        </GreenPageSection>

        <ImageWithContentSection
          subheadingText={<>Could You Be The Next <strong>Winner?</strong></>}
          imageSrc={`${imageDirectory}/secondary1.png`}
          imageAltText="grid of images showing friends and family on safari tour with giraffes and elephants"
        >
          <p>
            If you have any form of social media, this bucket-list experience couldn't have possibly slipped your attention: the Giraffe Manor in Nairobi! Picture yourself in the most stunning Kenyan landscape enjoying breakfast while unexpectedly a spotted long-necked friend joins in: one of the many giraffes who live around this gorgeous manor. If you thought that kind of thing only happened in Disney movies, think again!
          </p>

          <p>
            Take up to 5 friends/family members for a week in the Giraffe Manor and explore the gorgeous surroundings, go on a safari and jump on a helicopter for an unforgettable excursion.
          </p>

          <p>
            As this is a once-in-a-lifetime kind of trip, we'll also throw in £20k in spending money, so you can truly make the most of it!
          </p>

          <div className='ctaContainer'>
            <RoundedButton onClick={handleScrollToEntryMethodCards} style={{ width: 280 }}>
              Enter Now
            </RoundedButton>
          </div>
        </ImageWithContentSection>

        <ImageWithContentSection
          subheadingText={<>What's <strong>Included?</strong></>}
          imageSrc={`${imageDirectory}/secondary2.png`}
          imageAltText="mother and child feeding giraffe through their lodge window"
          reverseDesktopDirection
        >
          <ul style={{ fontWeight: 600 }}>
            <li>
              Return flights for up to 6 people
            </li>

            <li>
              Private transfers
            </li>

            <li>
              7-day stay in the Giraffe Manor in Nairobi for up to 6 people
            </li>

            <li>
              Breakfast included
            </li>

            <li>
              Helicopter excursion & transfers
            </li>

            <li>
              Private guided safari
            </li>

            <li>
              Up to £20,000 spending money
            </li>
          </ul>

          <div className='ctaContainer'>
            <RoundedButton onClick={handleScrollToEntryMethodCards} style={{ width: 280 }}>
              Enter Now
            </RoundedButton>
          </div>
        </ImageWithContentSection>

        <img
          src={`${ASSET_PREFIX}/images/prize-landing-pages/winner-row-1.png`}
          style={{
            width: '100%',
          }}
        />

        <WinnerContentSection
          onCtaClick={handleScrollToEntryMethodCards}
        />

        <img
          src={`${ASSET_PREFIX}/images/prize-landing-pages/winner-row-2.png`}
          style={{
            width: '100%',
          }}
        />

        <HowItWorksAndChoosePlanSection />
      </PrizeLandingPage>

      <style jsx>
        {`
          :global(.pageTitleGreenSectionContainer .pageTitle) {
            font-size: 2.1em;
          }
          
          @media(max-width: 500px) {
            :global(.pageTitleGreenSectionContainer .pageTitle) {
              font-size: 1.3em;
            }
          }
        `}
      </style>
    </MainLayout>
  );
};

export default StayAtGiraffeManor;
